
import * as styles from './Tutorial.styled';


const Tutorial = props => {

    return (
        <styles.Wrapper>
            In this step all you need to do is 
            <br />
            1. Create the quiz template
            <br />
            2. When user choose an answer, it should get highlighted.
        </styles.Wrapper>
    )
}

export default Tutorial;